var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconXBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.41,12l9.3,9.29-1.42,1.42L12,13.41l-9.29,9.3L1.29,21.29,10.59,12,1.29,2.71,2.71,1.29,12,10.59l9.29-9.3,1.42,1.42Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconXBig);
export default __webpack_public_path__ + "static/1787821308/media/icon-x-big.8d8df7712172c3218f2c51bef3b03ffa.svg";
export { ForwardRef as ReactComponent };